import { useContext, useEffect, useState } from 'react';
import Sidebar from '../Sidebar';
import ApiBlock from './ApiBlock';
import '../../css/Api.scss';
import api from '../../common/api';
import Skeleton from 'react-loading-skeleton';
import apiUrl from '../../assets/apiUrl';
import ConfirmDialog from '../ConfirmDialog';
import AuthContext, { getAccessToken } from '../Auth';
import withAuthenticationRequired from '../Auth/withAuthenticationRequired';

const Api = () => {
    const { fetchWrapper } = useContext(AuthContext);
    const [api, setApi] = useState<api[]>([]);
    useEffect(() => {
        (async () => {
            const data = await (await fetchWrapper(`${apiUrl}/api`)).json();
            setApi(data);
            setIsLoading(false);
        })();
    }, [fetchWrapper]);
    const create = async (master?: boolean) => {
        const path = master ? '/api?master=true' : '/api/';
        const token = await getAccessToken();
        const data = await (
            await fetchWrapper(`${apiUrl}${path}`, {
                method: 'POST',
                headers: { 'x-access-token': token },
            })
        ).json();
        setApi([...api, data]);
    };
    const deleteApi = async (apiKey: string) => {
        const token = await getAccessToken();
        await fetchWrapper(`${apiUrl}/api/${apiKey}`, {
            method: 'DELETE',
            headers: { 'x-access-token': token },
        });
        setApi(api.filter((e) => e.api_key !== apiKey));
    };
    const onRegenerate = async (apiKey: string) => {
        const token = await getAccessToken();
        const data = await (
            await fetchWrapper(`${apiUrl}/api/${apiKey}`, {
                method: 'PUT',
                headers: { 'x-access-token': token },
            })
        ).json();
        setApi([...api.filter((e) => e.api_key !== apiKey), data]);
    };
    const [isLoading, setIsLoading] = useState(true);
    const [open, setOpen] = useState(false);
    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = (confirm: boolean) => {
        if (confirm) {
            create(true);
        }
        setOpen(false);
    };
    return (
        <>
            <Sidebar />
            <div className="Api">
                <div className="container">
                    <button onClick={() => create()}>
                        <i className="far fa-plus-square" />
                        Create API
                    </button>
                    <ConfirmDialog
                        title={'Remember to be careful with the master key'}
                        text={
                            'If stolen it can be used to interact with your account.'
                        }
                        open={open}
                        cancelButtonText={'Cancel'}
                        confirmButtonText={'Create'}
                        handleClose={handleClose}
                    />
                    <button
                        onClick={() => {
                            handleClickOpen();
                        }}
                    >
                        <i className="fa fa-unlock-alt" />
                        Create Master key
                    </button>
                    <a
                        href="https://documenter.getpostman.com/view/12528592/TzJx7GHz"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <button>
                            <i className="fas fa-book" /> Read the docs
                        </button>
                    </a>
                    <div style={{ marginTop: '10px' }}>
                        {isLoading && [...Array(5)].map(() => <Skeleton />)}
                    </div>
                    {api.map((e) => (
                        <ApiBlock
                            api={e}
                            deleteApi={deleteApi}
                            onRegenerate={onRegenerate}
                        />
                    ))}
                </div>
            </div>
        </>
    );
};

export default withAuthenticationRequired(Api);
